(function () {
  'use strict';

  function initGallery(gallery) {
    var track = gallery.querySelector('[data-qcc-gallery-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-qcc-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-qcc-gallery-thumbnail]'));
    var current = gallery.querySelector('[data-qcc-gallery-current]');
    var previous = gallery.querySelector('[data-qcc-gallery-previous]');
    var next = gallery.querySelector('[data-qcc-gallery-next]');
    var activeIndex = 0;
    var ticking = false;

    if (!track || slides.length < 2 || thumbs.length !== slides.length) return;

    function update(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      if (current) current.textContent = String(activeIndex + 1);
      thumbs.forEach(function (thumb, thumbIndex) {
        var selected = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    function show(index) {
      var target = (index + slides.length) % slides.length;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: slides[target].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      update(target);
    }

    previous.addEventListener('click', function () { show(activeIndex - 1); });
    next.addEventListener('click', function () { show(activeIndex + 1); });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(Number(thumb.getAttribute('data-qcc-gallery-thumbnail'))); });
    });
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var width = track.clientWidth || 1;
        update(Math.round(track.scrollLeft / width));
        ticking = false;
      });
    }, { passive: true });
  }

  document.querySelectorAll('[data-qcc-location-gallery]').forEach(initGallery);
}());
